import { IErrorDetails } from "../Models";


export class ExtensionRequestError extends Error {
    details: IErrorDetails;

    constructor(message: string, details: IErrorDetails) {
        super(message);
        this.details = details;
    };
}